import { Directive, Output, EventEmitter } from '@angular/core';
import { byteLength } from './byte-length.function';
import { forwardRef, Input } from '@angular/core';
import { NG_VALIDATORS, AbstractControl } from '@angular/forms';
import { byteMinValidator } from './byte-min-validator';
import { byteMaxValidator } from './byte-max-validator';

@Directive({
    selector: '[byteLength][formControlName],[byteLength][formControl],[byteLength][ngModel]',
	providers: [{
		provide: NG_VALIDATORS,
		useExisting: forwardRef(() => ByteLengthDirective),
		multi: true
	}]
})
export class ByteLengthDirective {
    @Output('byteLengthChange') byteLengthChange:EventEmitter<number> = new EventEmitter();
    @Input() maxByte : number;
    @Input() minByte : number;
    constructor( 
    ) {
    }
    currentByteLength:number = 0;

    validate(control: AbstractControl) {
        this.currentByteLength = byteLength(control.value);
        this.byteLengthChange.next(this.currentByteLength);
  
        let error = null;
        if (this.minByte) {
            error = byteMinValidator(this.minByte)(control);
            if (error) return error;
        }
        if (this.maxByte) {
            error = byteMaxValidator(this.maxByte)(control);
            if (error) return error;
        }
        return null;
	}

}

